import { render, staticRenderFns } from "./PeriodeList.vue?vue&type=template&id=d3536a20&"
import script from "./PeriodeList.js?vue&type=script&lang=js&"
export * from "./PeriodeList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports